const name = 'circle-e';

const contents = '<path fill="#FFF" d="M40.57 55H21.43V26.829h18.974v4.64h-13.34v6.628h11.435v4.64H27.064v7.623H40.57z"/>';

/** @type {import ('./types').CharacterIcon} */
const icon = {
  name,
  contents,
  iconCharacter: 'E',
};

export default icon;
